import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { IllustMark } from '@/components/IllustMark'
import { RememberHome } from '@/screens/RememberHome'

const Map = lazy(async () => ({ default: (await import('@/screens/Map')).Map }))
const AR = lazy(async () => ({ default: (await import('@/screens/AR')).AR }))
const Camera = lazy(async () => ({ default: (await import('@/screens/Camera')).Camera }))
const Preview = lazy(async () => ({ default: (await import('@/screens/Preview')).Preview }))
const Admin = lazy(async () => ({ default: (await import('@/screens/Admin')).Admin }))

const RouteFallback = () => (
  <div className="mem-page mem-page--center" aria-busy="true" aria-live="polite">
    <main className="mem-main">
      <p style={{ margin: 0, color: 'var(--mem-text-muted)' }}>Loading…</p>
    </main>
  </div>
)

export function Router() {
  return (
    <BrowserRouter>
      <IllustMark />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<RememberHome />} />
          <Route path="/remember" element={<Navigate to="/camera" replace />} />
          <Route path="/map" element={<Map />} />
          <Route path="/ar" element={<AR />} />
          <Route path="/camera" element={<Camera />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
